import router from "./router";
import store from "./store";
import {
  getToken,
  getRefreshToken,
  // getUserID,
  clearCookies,
  checkExternalPanelist,
  //  checkTokenExpiry
} from "./utils/tokenCheck.js";
// import checkToken from "./utils/tokenCheck.js";
// import { getLoggedInUserEmail } from "./utils/request.js";
import { getVendorClients } from "./utils/apiFunctions.js";

const hasPermission = (roles, permissionRoles) => {
  if (roles.includes("admin")) return true; // admin permission passed directly
  if (!permissionRoles) return true;
  return roles.some((role) => permissionRoles.includes(role));
};

export const checkAccess = () => {
  if (document.cookie.length > 0) {
    let data = document.cookie.split(";");
    for (let i in data) {
      let cur = data[i].split("=");
      if (cur[0].trim() === "recruitment") {
        if (cur[1] === "no-access") {
          return false;
        } else {
          return true;
        }
      }
    }
  }
  return false;
};

// page title function
const title = "Recruitment";

const getPageTitle = (pageTitle) => {
  if (pageTitle === "Registration") {
    return `Registration`;
  }
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
};

const getTitleName = (titleName) => {
  if (titleName != "undefined" && titleName != "null") {
    let val = titleName.replace(/(?<=\p{Ll})(?=\p{Lu})/gu, " ");
    if (titleName == "workBench") {
      return "Workbench";
    } else {
      return val;
    }
  }
};

const getClients = async () => {
  try {
    let payload = {
      searchQuery: null,
      sort: "+organizationName",
    };
    const res = await getVendorClients(payload);
    if (res.status == 200) {
      return res.data.data;
    }
  } catch (error) {
    return error;
  }
};

const checkAndRedirect = async (next) => {
  if (!store.getters["userVUEX/getVendorData"]) {
    const clientData = await getClients();
    if (clientData.length == 1) {
      let vendorIDVal = clientData[0].vendorID;
      let clientNameVal = clientData[0].clientName;
      store.commit("userVUEX/setVendorData", {
        vendorID: vendorIDVal,
        clientName: clientNameVal,
      });
      next(
        `/vendorlogin/jobs/${vendorIDVal}/${clientNameVal}?clientName=${clientNameVal}`
      );
    } else {
      store.commit("userVUEX/setVendorData", {});
      next();
    }
    if (clientData.length != 0)
      store.commit("userVUEX/setVendorID", clientData[0].vendorID);
  } else if (Object.keys(store.getters["userVUEX/getVendorData"]).length != 0) {
    let vendorIDVal = store.getters["userVUEX/getVendorData"].vendorID;
    let clientNameVal = store.getters["userVUEX/getVendorData"].clientName;
    document.title = "Jobs - Recruitment";
    next(
      `/vendorlogin/jobs/${vendorIDVal}/${clientNameVal}?clientName=${clientNameVal}`
    );
  } else next();
};
// const whiteList = ["/login", "/forgot"];
// const whiteListOne = ["JobRegistration", "FareWellPage", "Registration"];
router.beforeEach(async (to, from, next) => {
  // set page title
  if (to.name === "CreateJob") {
    const type = to.query.type || "Create";
    to.meta.title = `${type} Job`;
  }
  let titleName = to.meta.title || to.name;
  const titlevalue = getTitleName(String(titleName));
  document.title = getPageTitle(titlevalue);
  if (
    to.name === "Registration" ||
    to.name === "JobRegistration" ||
    to.name === "ResumeChecker" ||
    to.name === "JobNotFound" ||
    ((to.path == "/jobs/paneldetails" || to.path == "/jobs/paneldetails/") &&
      checkExternalPanelist())
  ) {
    // if (to.name === "Registration"){
    next();
  } else if (checkAccess()) {
    const hasToken = getToken();
    if (hasToken) {
      // const expiryTime = checkTokenExpiry();
      // if (expiryTime) {
      //   next();
      // } else {
      //   localStorage.clear();
      //   store.dispatch("userVUEX/LogOut");
      //   next(`/login?redirect=${to.path}`);
      // }
      if (to.path == "/jobs/paneldetails" || to.path == "/jobs/paneldetails/") {
        store.commit("userVUEX/setPanelID", to.query.uuid);
      }
      if (
        to.path === "/login" ||
        to.path === "/forgot" ||
        to.path === "/register"
      ) {
        next({ path: "/" });
      } else {
        // determine whether the user has obtained his permission roles through getInfo
        // const hasRoles = store.getters.roles && store.getters.roles.length > 0
        if (store.getters.roles.length === 0) {
          store
            .dispatch("userVUEX/getUserData", "setRole")
            .then((res) => {
              const data = res;
              const permissions = data.permissions;
              // generate accessible routes map based on roles
              store
                .dispatch("GenerateRoutes", { permissions })
                .then(async (accessRoutes) => {
                  // dynamically add accessible routes
                  router.addRoutes(accessRoutes);

                  router.options.routes =
                    router.options.routes.concat(accessRoutes);

                  // hack method to ensure that addRoutes is complete
                  // set the replace: true, so the navigation will not leave a history record
                  let token = localStorage.getItem("accessToken");
                  store.commit("userVUEX/SET_TOKEN", getToken());
                  store.commit("userVUEX/SET_REFRESH_TOKEN", getRefreshToken());
                  if (token != null && token !== getToken()) {
                    token = null;
                  }
                  if (token != null) {
                    let landingpages = [
                      "/panellogin",
                      "/approval/viewjds",
                      "/hr/dashboard",
                      "/permission/access",
                      "/vendorlogin",
                      "/my-board",
                      "/permission/access?status=roles",
                      "/data/manage?status=customer",
                      "/data/manage?status=manage",
                      "/permission/panel/list",
                      "/talentpool/",
                      "/report/",
                      "/hiringprocess/dashboard?status=interviewProcess",
                      "/hiringprocess/dashboard?status=feedbackForm",
                      "/approval/reviewcandidates",
                      "/search/profiles",
                      "/customfield/customform",
                      "/thirdparty/home",
                      "/teams",
                    ];
                    store.commit("userVUEX/setPanelID", null);
                    if (
                      to.path == "/vendorlogin/vendordashboard" ||
                      to.name == "clientdashboard"
                    ) {
                      await checkAndRedirect(next);
                    } else if (to.query.from) {
                      next({
                        path: store.getters.landingPage.landingPage,
                        replace: true,
                      });
                    } else if (
                      to.path == "/" &&
                      landingpages.includes(
                        store.getters.landingPage.landingPage
                      )
                    ) {
                      next({
                        path: store.getters.landingPage.landingPage,
                        replace: true,
                      });
                    } else {
                      next({ ...to, replace: true });
                    }
                  } else {
                    store.commit("userVUEX/setPanelID", null);
                    localStorage.setItem("accessToken", getToken());
                    if (
                      to.path == "/jobs/paneldetails/" &&
                      to.query.uuid &&
                      to.query.panel
                    ) {
                      store.commit("userVUEX/setPanelID", to.query.uuid);
                      // console.log(checkPanelist(to.query.uuid));
                      next({ ...to, replace: true });
                    } else if (to.query.from == "login") {
                      next({
                        path: to.path,
                        replace: true,
                      });
                    } else {
                      if (
                        to.path == "/vendorlogin/vendordashboard" ||
                        to.name == "clientdashboard"
                      ) {
                        await checkAndRedirect(next);
                      } else {
                        next({
                          path: store.getters.landingPage.landingPage,
                          replace: true,
                        });
                      }
                    }
                  }
                });
            })
            .catch((err) => {
              clearCookies();
              if (
                (to.path == "/jobs/paneldetails/" ||
                  to.path == "/jobs/paneldetails") &&
                to.query.uuid &&
                to.query.panel
              ) {
                location.replace(
                  `https://app.hire3x.com/login?from=recruitment&uuid=${to.query.uuid}&panel=${to.query.panel}`
                  // `http://localhost:8080/login?from=recruitment&uuid=${to.query.uuid}&panel=${to.query.panel}`
                );
              } else if (to.path.startsWith("/givefeedback")) {
                // location.replace(`http://localhost:8080/login?from=recruitment&redirect=${to.path}`)
                location.replace(
                  `https://app.hire3x.com/login?from=recruitment&redirect=${to.path}`
                );
              } else {
                location.replace(
                  `https://app.hire3x.com/login?from=recruitment`
                  // `http://localhost:8080/login?from=recruitment`
                );
              }
              throw err;
            });
        } else {
          // To check if user has role the component
          if (hasPermission(store.getters.roles, to.meta.routes)) {
            if (
              to.path == "/vendorlogin/vendordashboard" ||
              to.name == "clientdashboard"
            ) {
              await checkAndRedirect(next);
            } else next();
          } else {
            next({ path: "/404", replace: true, query: { noGoBack: true } });
          }
        }
      }
    } else {
      localStorage.removeItem("accessToken");
      clearCookies();
      // location.replace("http://localhost:8082/");
      location.replace("https://app.hire3x.com/login?from=recruitment");
      /* has no token*/
      // if (whiteList.includes(to.path)) {
      //   next();
      // } else {
      //   // other pages that do not have permission to access are redirected to the login page.
      //   next(`/login?redirect=${to.path}`);
      // }
    }
  } else if (to.query.intid) {
    clearCookies();
    location.replace(
      `https://app.hire3x.com/login?from=recruitment&intid=${to.query.intid}&type=${to.query.type}`
      // `http://localhost:8080/login?from=recruitment&uuid=${to.query.uuid}&panel=${to.query.panel}`
    );
  } else if (to.query.uuid && to.query.panel) {
    store.commit("userVUEX/setPanelID", null);
    clearCookies();
    location.replace(
      `https://app.hire3x.com/login?from=recruitment&uuid=${to.query.uuid}&panel=${to.query.panel}`
      // `http://localhost:8080/login?from=recruitment&uuid=${to.query.uuid}&panel=${to.query.panel}`
    );
  } else {
    localStorage.removeItem("accessToken");
    clearCookies();
    if (to.path.startsWith("/givefeedback")) {
      // location.replace(`http://localhost:8080/login?from=recruitment&redirect=${to.path}`)
      location.replace(
        `https://app.hire3x.com/login?from=recruitment&redirect=${to.path}`
      );
    } else {
      location.replace("https://app.hire3x.com/login?from=recruitment");
    }
  }
});

// To remove Navigation Errors
const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (
      err.name !== "NavigationDuplicated" &&
      !err.message.includes("Redirected when going from")
    ) {
      throw err;
    }
  });
};

router.afterEach(() => {});
